// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  cursor: default;
  --presence-size: 12px;
}
:host .border {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: visible;
}
:host .border img {
  border-radius: 50%;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border: 0;
}
:host .point-indicator {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: var(--presence-size);
  height: var(--presence-size);
  border-radius: 50%;
  border: none;
}
:host .point-indicator.online {
  background: #1FD948;
}

:host.contact-card-enabled {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui-components/user-avatar/user-avatar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;AACJ;AAqCI;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAnCN;AAuCE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;AArCJ;AAuCI;EACE,mBAAA;AArCN;;AA0CA;EACE,eAAA;AAvCF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  cursor: default;\n  --presence-size: 12px;\n\n  .border {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    overflow: visible;\n\n    //&.with-light {\n    //  border: 3px solid white;\n    //  box-shadow: 0px 0px 15px rgba(white, 0.6),\n    //  inset 0px 0px 10px rgba(white, 0.5);\n    //  filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //\n    //  &.none-light {\n    //    box-shadow: inset 0px 0px 10px rgba(white, 0.5);\n    //    filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //  }\n    //\n    //  &.small-light {\n    //    box-shadow: 0px 0px 15px rgba(white, 0.6),\n    //    inset 0px 0px 10px rgba(white, 0.5);\n    //    filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //  }\n    //\n    //  &.medium-light {\n    //    box-shadow: 0px 0px 25px rgba(white, 0.6),\n    //    inset 0px 0px 10px rgba(white, 0.5);\n    //    filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //  }\n    //\n    //  &.big-light {\n    //    box-shadow: 0px 0px 35px rgba(white, 0.6),\n    //    inset 0px 0px 10px rgba(white, 0.5);\n    //    filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //  }\n    //\n    //  &.super-big-light {\n    //    box-shadow: 0px 0px 65px rgba(white, 0.9),\n    //    inset 0px 0px 10px rgba(white, 0.5);\n    //    filter: drop-shadow(0px 0px 50px rgba(white, 0.5));\n    //  }\n    //}\n\n    img {\n      border-radius: 50%;\n      object-fit: cover;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n  }\n\n  .point-indicator {\n    position: absolute;\n    bottom: 0px;\n    right: 0px;\n    width: var(--presence-size);\n    height: var(--presence-size);\n    border-radius: 50%;\n    border: none;\n\n    &.online {\n      background: #1FD948;\n    }\n  }\n}\n\n:host.contact-card-enabled {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
